/** Zona horaria Chile (continental). */
export const CHILE_TIMEZONE = 'America/Santiago';

const chileFormatter = new Intl.DateTimeFormat('es-CL', {
  timeZone: CHILE_TIMEZONE,
  dateStyle: 'short',
  timeStyle: 'medium',
});

/**
 * Formatea una fecha ISO del backend en calendario y hora de Chile (CL).
 */
export function formatDateTimeCL(iso?: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return chileFormatter.format(d);
}
